const actions = {
  home: ({ commit }) => {
    commit("SetIsHome", true);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  account: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", true);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  transfer: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", true);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  fund: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", true);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  utility: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", true);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  loan: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", true);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  investment: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", true);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc1: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", true);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc2: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", true);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc3: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", true);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc4: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", true);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc5: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", true);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc6: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", true);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc7: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", true);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc8: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", true);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", false);
  },
  misc9: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", true);
    commit("SetIsMisc10", false);
  },
  misc10: ({ commit }) => {
    commit("SetIsHome", false);
    commit("SetIsAccount", false);
    commit("SetIsTransfer", false);
    commit("SetIsFund", false);
    commit("SetIsUtility", false);
    commit("SetIsLoan", false);
    commit("SetIsInvestment", false);
    commit("SetIsMisc1", false);
    commit("SetIsMisc2", false);
    commit("SetIsMisc3", false);
    commit("SetIsMisc4", false);
    commit("SetIsMisc5", false);
    commit("SetIsMisc6", false);
    commit("SetIsMisc7", false);
    commit("SetIsMisc8", false);
    commit("SetIsMisc9", false);
    commit("SetIsMisc10", true);
  }
};
export { actions };
